import { Skeleton } from '@shared/ui';

import styles from './VehicleCard.module.css';

/**
 * Плейсхолдер карточки автомобиля — витрины рабочего набора (FE-586).
 *
 * Повторяет геометрию `VehicleCard` с действием во всю ширину, поэтому
 * появление данных ничего не сдвигает. Скрыт от скринридеров: о загрузке
 * сообщает статус-строка списка.
 */
export function VehicleCardSkeleton() {
  return (
    <div className={`${styles.card} ${styles.skeletonCard}`} aria-hidden="true">
      <div className={styles.skeletonMedia}>
        <Skeleton height="100%" radius="0" />
      </div>
      <div className={styles.body}>
        <Skeleton height="1.1rem" width="60%" />
        <Skeleton height="0.85rem" width="80%" />
        <div className={styles.skeletonSpecs}>
          <Skeleton height="0.85rem" width="70%" />
          <Skeleton height="0.85rem" width="80%" />
          <Skeleton height="0.85rem" width="60%" />
          <Skeleton height="0.85rem" width="75%" />
        </div>
        <div className={styles.skeletonFooter}>
          <Skeleton height="1.5rem" width="45%" />
          <Skeleton height="0.85rem" width="25%" />
        </div>
      </div>
      <div className={styles.action}>
        <Skeleton height="var(--control-height-md)" radius="var(--radius-control)" />
      </div>
    </div>
  );
}
